import * as moment from 'moment';
import { IPromoCodeDetail } from './promo-code';

export enum CalendarDeviceMode {
    DESKTOP,
    MOBILE
}

export enum CalendarViewMode {
    GRID,
    LIST
}

export interface ICalendarSettings {
    loadWrappingMonthDates: boolean;
    saveHistory: boolean;
    monthsOnCalendar: moment.Moment[];
    calendarDeviceMode: CalendarDeviceMode;
    calendarViewMode: CalendarViewMode;
    desktopToMobileTransitionWidth: string;
    scrollToTopAppearanceOffset: number;
    filtersAlwaysModal: boolean;
    promoCode: IPromoCodeDetail;
}

const calendarEntry = document.getElementById("calendar-entry-js");

export const defaultCalendarSettings: ICalendarSettings = {
    loadWrappingMonthDates: false,
    saveHistory: false,
    monthsOnCalendar: [],
    calendarDeviceMode: CalendarDeviceMode.DESKTOP,
    calendarViewMode: CalendarViewMode.GRID,
    desktopToMobileTransitionWidth: calendarEntry && calendarEntry.getAttribute("data-calendar-breakpoint") ? calendarEntry.getAttribute("data-calendar-breakpoint") : "1024px",
    scrollToTopAppearanceOffset: parseInt(calendarEntry && calendarEntry.getAttribute("data-scroll-to-top-offset") ? calendarEntry.getAttribute("data-scroll-to-top-offset") : "500"),
    filtersAlwaysModal: calendarEntry && Boolean(calendarEntry.getAttribute("data-filter-always-modal")) ? Boolean(calendarEntry.getAttribute("data-filter-always-modal")) : false,
    promoCode: null
}